module.exports = __webpack_public_path__ + "img/g6.0e8277c1.png";